var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.534 59.14a47.312 47.312 0 1094.625 0 47.312 47.312 0 00-94.625 0z",
    fill: "#EEF1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.943 26.999H83.3v52.557H20.943V26.999z",
    fill: "#fff",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3 43.033H20.943V30.216a3.217 3.217 0 013.216-3.217h55.923a3.217 3.217 0 013.218 3.217v12.817z",
    fill: "#ADB8F2",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.943 51.942H83.3M20.943 60.85H83.3M20.943 69.758H83.3M33.415 43.033v36.524M45.885 43.033v36.524M58.356 43.033v36.523M70.828 43.033v36.523",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.943 51.942h12.471v8.908H20.943v-8.908zM33.415 69.758h12.472v9.798H33.415v-9.798zM45.885 43.033h12.471v8.908H45.885v-8.908z",
    fill: "#ADB8F2",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.216 86.481c0 .692 1.923 1.356 5.347 1.845 3.424.489 8.067.764 12.91.764 4.842 0 9.485-.275 12.909-.764 3.424-.49 5.347-1.153 5.347-1.845 0-.691-1.923-1.355-5.347-1.844-3.424-.489-8.068-.764-12.91-.764-4.842 0-9.485.275-12.909.764-3.424.49-5.347 1.153-5.347 1.844z",
    fill: "#ADB8F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.165 60.494V46.929a3.876 3.876 0 00-6.614-2.74 3.875 3.875 0 00-1.135 2.74v13.565h7.75z",
    fill: "#fff",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.218 90.731a.591.591 0 00-.584.522 5.957 5.957 0 00-.037.654 5.878 5.878 0 0011.756 0c0-.219-.012-.437-.036-.654a.592.592 0 00-.585-.522H71.218z",
    fill: "#ADB8F2",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.544 85.614a3.516 3.516 0 01-1.456-2.839V71.337c0-10.547-7.91-19.13-17.633-19.13-9.723 0-17.632 8.583-17.632 19.13v11.435a3.515 3.515 0 01-1.457 2.838l38.178.005z",
    fill: "#fff",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 88.704a3.096 3.096 0 01-.905 2.185 3.087 3.087 0 01-2.185.904H56.035a3.09 3.09 0 110-6.179h41.198a3.088 3.088 0 013.09 3.09zM30.527 32.732a1.729 1.729 0 11-3.455 0V22.367a1.728 1.728 0 013.455 0v10.365zM44.347 32.732a1.729 1.729 0 11-3.455 0V22.367a1.729 1.729 0 013.455 0v10.365zM63.35 32.732a1.727 1.727 0 11-3.455 0V22.367a1.728 1.728 0 013.455 0v10.365zM77.17 32.732a1.727 1.727 0 11-3.455 0V22.367a1.728 1.728 0 013.455 0v10.365zM81.656 64.979a14.545 14.545 0 1029.09 0 14.545 14.545 0 00-29.09 0z",
    fill: "#fff",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.202 65.94a1.864 1.864 0 01-1.808-1.407l-.961-3.785c-.25-.8-.447-1.617-.592-2.443a3.364 3.364 0 116.713-.008c-.142.83-.34 1.65-.591 2.455L98 64.537a1.864 1.864 0 01-1.8 1.402zM96.202 75.414a3.365 3.365 0 11-.002-6.73 3.365 3.365 0 01.002 6.73z",
    fill: "#ADB8F2",
    stroke: "#444D56",
    strokeWidth: 1.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNoNotifications;